<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'SelectionPopup',
  props: {
    popUpHeadline: String,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['selectionPopup', 'selectionPopupItems', 'step', 'selectionZipCodeFirst', 'selectionZipCodeSecond']),

    toggleModal() {
      if (this.selectionPopup) {
        this.$nextTick(() => {
          $('#selectionPopupModal').modal('show');
        });
        return true;
      }else {
        return false;
      }
    },
    modalContent(){
      let result = [];
      if (this.selectionPopupItems) {
        this.selectionPopupItems.forEach((item, i) => {
          result.push({
            id: item.id,
            stadt: item.stadt,
            level: item.level
          });
        });
      }
      return result;
    }
  },
  methods: {
    ...mapActions([
      'getPriceInfoAction'
    ]),
    localClicked(id, level) {
      let secondForm = false;
      let zipCode = this.selectionZipCodeFirst;
      this.$store.commit('SET_SELECTION_POPUP_LEVEL', level);

      if (this.step === 1) {
        this.$store.commit('SET_SELECTION_POPUP_ZIPID', id);
      }else if (this.step === 2) {
        this.$store.commit('SET_SELECTION_POPUP_ZIPID_SECOND', id);
        secondForm = true;
        zipCode = this.selectionZipCodeSecond;
      }

      this.getPriceInfoAction({ zipcode: zipCode, priceForSecondForm: secondForm });

      this.$nextTick(() => {
        $('#selectionPopupModal').modal('hide');
        this.$store.commit('SET_SELECTION_POPUP', false);
        this.$store.commit('SET_SELECTION_POPUP_ITEMS', []);
        //window.scrollTo(0, -100);
      });
    },
  },
};
</script>

<template>
  <div v-if="toggleModal" class="form-popup-selection">
    <button id="selectionPopupTrigger" data-toggle="modal" data-target="#selectionPopupModal"></button>
    <div class="modal fade" id="selectionPopupModal" tabindex="-1" role="dialog" aria-labelledby="selectionPopupModal" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="selectionPopupModal">{{ popUpHeadline }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-for="(item, index) in modalContent" v-bind:key="index">
              <button @click="localClicked(item.id, item.level)" class="sel-btn btn btn-primary" :ref="item.id">{{ item.stadt }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  @import 'SelectionPopup';
</style>
